import { locateProject } from '../config/paths';
import { readdirSync } from 'fs';
import path from 'path';
import 'reflect-metadata'
import ApplicationError from '../shared/models/application-error';
import BacklogItem from '../shared/models/backlog-item';
import BacklogItemCategory from '../shared/models/backlog-item-category';
import BacklogLane from '../shared/models/backlog-lane';
import Session from '../shared/models/session';
import User from '../shared/models/user';
import { DataSource } from "typeorm";

/** The data source */
export default new DataSource({
    type: 'mysql',
    host: 'localhost',
    port: 3306,
    username: process.env.DB_USER,
    password: process.env.DB_PASSWORD,
    database: process.env.DB_DATABASE,
    synchronize: false,
    logging: process.env.DB_LOGGING === 'true',
    entities: [
        ApplicationError,
        BacklogItemCategory,
        BacklogItem,
        BacklogLane,
        Session,
        User
    ],
    migrations: [
        path.join(locateProject(process.cwd())!, "./backend/migrations/**/*.{ts,js}")
    ],
    migrationsRun: true,
    migrationsTableName: '_migrations',
    migrationsTransactionMode: 'all'
})

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 39,line: "declare var require: NodeJS.Require & {"});
declare var require: NodeJS.Require & {
    context(
      path: string, // Path to directory
      deep: boolean, // Whether to include subdirectories
      filter: RegExp // Regular expression for filtering files
    ): {
      keys(): string[]; // Returns an array of matched module paths
      (id: string): any; // Allows access to the matched module
      resolve(id: string): string; // Resolves the path of the module
    };
};